import api from "../../core/api";
import { ChangeServiceReport, MachinePartGroup, ServiceReport, ServiceReportsQuery } from "../models/serviceReportsModels";
import { saveBlobAsFile } from "../../shared/utils/fileUtils";

const getRequestConfig = () => {
  return { baseURL: (window as any).app.config.machineryApiBaseUrl };
};

class PublicServiceReportsApi {
  getServiceReports(machineNumber: string, query: ServiceReportsQuery): Promise<ServiceReport[]> {
    return api
      .get<ServiceReport[]>(`/v1/public/machines/${machineNumber}/service-reports`, {
        ...getRequestConfig(),
        params: query,
        paramsSerializer: { indexes: null }
      })
      .then((x) => x.data);
  }

  getServiceReport(serviceReportNumber: string): Promise<ServiceReport> {
    return api.get<ServiceReport>(`/v1/public/service-reports/${serviceReportNumber}`, getRequestConfig()).then((x) => x.data);
  }

  createServiceReport(model: ChangeServiceReport, machineNumber: string): Promise<string> {
    return api.post<string>(`/v1/public/machines/${machineNumber}/service-reports`, model, getRequestConfig()).then((x) => x.data);
  }

  changeServiceReport(serviceReportNumber: string, model: ChangeServiceReport) {
    return api.put<any>(`/v1/public/service-reports/${serviceReportNumber}`, model, getRequestConfig());
  }

  createSolvingServiceReport(serviceReportNumber: string, model: ChangeServiceReport) {
    return api
      .post<string>(`/v1/public/service-reports/${serviceReportNumber}/solving-report`, model, getRequestConfig())
      .then((x) => x.data);
  }

  deleteServiceReport(serviceReportNumber: string): Promise<any> {
    return api.delete(`/v1/public/service-reports/${serviceReportNumber}`, getRequestConfig());
  }

  async getServiceReportPdfLink(serviceReportNumber: string, filename: string) {
    const url = `/v1/public/service-reports/${serviceReportNumber}/pdf`;
    const response = await api.get(url, {
      responseType: "blob",
      baseURL: getRequestConfig().baseURL,
    });
    saveBlobAsFile(response.data, filename);
  }

  getMachineParts(): Promise<MachinePartGroup[]> {
    return api.get<MachinePartGroup[]>(`/v1/machine-parts`, getRequestConfig()).then((x) => x.data);
  }
}

export default new PublicServiceReportsApi();